import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CardElement, injectStripe } from 'react-stripe-elements';
import { Button } from 'antd';
import {
  SafetyOutlined,
} from '@ant-design/icons';

class PaymentMethodForm extends Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }
  state = { ready: false };

  static propTypes = {
    stripe: PropTypes.object.isRequired,
    addCard: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
  };

  async submit() {
    const { token } = await this.props.stripe.createToken();
    this.props.addCard(token);
  }

  handleChange = (change) => {
    this.setState({ ready: change.complete });
  };

  handleFocus = () => {
    this.props.onFocus();
  };

  render() {
    return (
      <div>
        <div className="p-3" style={{ backgroundColor: '#F5F6FA' }}>
          <CardElement
            hidePostalCode={false}
            onChange={this.handleChange}
            onFocus={this.handleFocus}
          />
        </div>
        <div className="text-muted mt-2" style={{ fontSize: '12px', opacity: '0.5' }}>
          Credit cards are processed with bank-grade security &amp; never stored on PageHits' servers.
        </div>
        <Button
          disabled={!this.state.ready}
          type="primary" className="mt-4 mb-3" icon={<SafetyOutlined />} onClick={this.submit}
        >
          Add Card
        </Button>
      </div>
    );
  }
}

export default injectStripe(PaymentMethodForm);



// WEBPACK FOOTER //
// ./scripts/presentation/PaymentMethodForm.jsx